import {AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit, SimpleChanges} from '@angular/core';
import {MaskConversionTypes} from '@aposin/ng-aquila/mask';
import {CustomMaskInputs} from '../../enums/custom-mask-inputs';

@Component({
    templateUrl: './custom-mask.component.html',
    styleUrls: ['./custom-mask.component.scss'],
    standalone: false
})
export class CustomMaskComponent {
  @Input() [CustomMaskInputs.MASK]: string | null = null;
  @Input() [CustomMaskInputs.TEXT]: string = '';
  @Input() [CustomMaskInputs.FOCUS]: boolean = false;
  @Input() [CustomMaskInputs.CONVERT]!: MaskConversionTypes;
  @Input() [CustomMaskInputs.ALIGN_RIGHT]: boolean = false;
}
